import { Component, Inject, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { EnvironmentService } from "../../core/environment.service";
import { WINDOW } from "../../shared/app.window";
import { BaseComponent } from "../../shared/base.component";

@Component({
  selector: "app-logoff",
  templateUrl: "./logoff.component.html",
  styleUrls: ["./logoff.component.scss"]
})
export class LogoffComponent extends BaseComponent implements OnInit {
  override componentTranslationRoot = "logoff";

  constructor(
    private environmentService: EnvironmentService,
    translateService: TranslateService,
    @Inject(WINDOW) private window: Window
  ) {
    super(translateService);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.redirectToStartPortal();
    }, 5000);
  }

  redirectToStartPortal() {
    this.window.location.href = this.environmentService.startPortalUrl;
  }
}


